import(/* webpackMode: "eager" */ "/app/app/(legal)/[lang]/terms/page.tsx");
